<script>
  import { createEventDispatcher } from 'svelte';

  export let open = false;
  export let theme = false;

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('click');
  }
</script>

<button class={`burger ${theme}`} class:open on:click={handleClick}>
  <div class="burger__inner">
    <span class="burger__line" />
    <span class="burger__line" />
    <span class="burger__line" />
  </div>
</button>

<style lang="scss">
  .burger {
    padding: 1rem;

    &__inner {
      position: relative;
      width: 4rem;
      height: 4rem;

      transition: all 0.25s;

      @include resp-max('s') {
        width: 2.3rem;
        height: 2.7rem;
      }

      .open & {
        transform: rotate(180deg);
      }
    }

    &__line {
      position: absolute;
      left: 0;

      display: block;
      width: 100%;
      height: 2px;

      transition: all 0.2s;

      .dark & {
        background-color: var(--royal);
      }

      .light & {
        background-color: rgb(var(--white));
      }

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2) {
        top: 50%;
        margin-top: -1px;
      }

      &:nth-child(3) {
        bottom: 0;
      }

      .open & {
        &:nth-child(1),
        &:nth-child(3) {
          left: 50%;
          margin-left: -2rem;
        }

        &:nth-child(1) {
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
        }

        &:nth-child(2) {
          width: 0;
        }

        &:nth-child(3) {
          bottom: 50%;
          transform: translateY(50%) rotate(-45deg);
        }
      }
    }

    &:hover {
      .burger__line {
        background-color: var(--aqua-1);
      }
    }

    &:focus-visible {
      outline: none;
    }
  }
</style>
